/**
 * Phase 0.5 — display-name resolution.
 *
 * A contact's visible name prefers the user's personal label
 * (`local_display_name`, surfaced as "Display Name") and falls back to
 * first + last. `canonical_name` is the connected user's real identity,
 * shown subtly as "Real name: …" only when it differs from what's displayed.
 */
export function contactDisplayName(c) {
  if (!c) return '';
  const local = (c.local_display_name || '').trim();
  if (local) return local;
  const full = `${c.first_name || ''} ${c.last_name || ''}`.trim();
  return full || c.nickname || c.work?.company || c.organization || '';
}

export function contactRealName(c) {
  if (!c) return '';
  const canon = (c.canonical_name || '').trim();
  if (!canon) return '';
  const shown = contactDisplayName(c);
  return canon.toLowerCase() === shown.trim().toLowerCase() ? '' : canon;
}
